import { Button, Col, Input, Label, Row } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Monthly, PricePlanText, PricePlanTitle, Yearly } from "../../Constants/Constants";
import { PricePlanData } from "../../Data/Landing/Landing";
import { dynamicImage, Image } from "../../Utils";
import { PricePlanSettingsData } from "../../Data/Messenger/Messenger";

const PricePlan = () => {
  return (
    <section className="section-py-space pricing-section">
      <div className="custom-container">
        <Row>
          <Col xs="12">
            <div className="content-title">
              <h3>{PricePlanTitle}</h3>
              <h2>{PricePlanText}</h2>
              <span />
            </div>
          </Col>
          <Col xs="12">
            <div className="pricing-tag">
              <h3>{Monthly} </h3>
              <Label className="switch mb-0">
                <Input type="checkbox" defaultChecked />
                <span className="switch-state" />
              </Label>
              <h3>{Yearly} </h3>
            </div>
          </Col>
          <Col xs="12">
            <div className="price-slider ">
              <div className="slider-container">
                <Swiper {...PricePlanSettingsData} className="mySwiper">
                  {PricePlanData.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div className="pricing-box">
                        <div>
                          <div className="pricing-icon"><Image className="img-fluid" src={dynamicImage(item.image)} alt="pricing-plan" /></div>
                          <div className="pricing-content">
                            <span>{item.plan} </span>
                            <h2>{item.price}<span>/ Month</span></h2>
                          </div>
                        </div>
                        <h4>{item.description}</h4>
                        <ul className="avb-price">
                          {item.features.map((feature, featureIndex) => (
                            <li key={featureIndex}><i className="fa fa-check" /> {feature}</li>
                          ))}
                        </ul>
                        <Button className="pricing-btn">{item.buttonText}<i className="fa fa-angle-right" /></Button>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default PricePlan;
